var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[(_vm.showUserName)?_c('div',{staticClass:"welcome"},[_vm._v(" "+_vm._s(_vm.welcomeMessage)+" ")]):_vm._e(),_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c(Component,{tag:"component"})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }